module.exports = __webpack_public_path__ + "img/rever-filter-icon.c005f52b.svg";